<template>
  <div class="container-page-result">
    <header-component :title="translate.result.headerTitleResult" />
    <main>
      <b-card no-body>
        <b-card-body>
          <message-result 
            :businessName="businessName" 
            :type="type"  
          />
        </b-card-body>
      </b-card>
    </main>
  </div>
</template>

<script>
import HeaderComponent from './Header.vue';
import MessageResult from './MessageResult.vue';

export default {
  name: 'pageResult',
  components: {
    HeaderComponent,
    MessageResult
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
    businessName() {
      return this.$route.query.businessName;
    },
    type() {
      return this.$route.query.type;
    },
  },
};
</script>
<style lang="scss" scoped>
.container-page-result {
  main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #000;
    width: 100%;
    margin-top: 60px;
    margin-bottom: 60px;
    padding: 10px;
  }

  .card {
    padding: 1rem;
    width: 100%;
    max-width: 650px;
    font-size: 12px;
    text-align: left;
    border: 1px solid #dfe0e0;
    border-radius: 5px;
    background: #fff;
  }

  .card-body {
    padding: 0px;
  }
}
</style>
